export default "__VITE_ASSET__KdBc8tzP__"